module.exports = __webpack_public_path__ + "734f0058a2c6e23937309c088c4480bb.svg";